window.addEventListener("load", () => {

  const submitForm = document.getElementById("submitForm");
  const errorMessage = document.getElementById("service_category_error");
  const postErrorMessage = document.getElementById("post_code_error");
  const postInput = document.getElementById("user_postcode");
  const lNameErrorMessage = document.getElementById("last_name_error");
  const lastNameInput = document.getElementById("last_name");
  const fNameErrorMessage = document.getElementById("first_name_error");
  const firstNameInput = document.getElementById("first_name");
  const lNameKanaErrorMessage = document.getElementById("last_name_kana_error");
  const lastNameKanaInput = document.getElementById("last_name_kana");
  const fNameKanaErrorMessage = document.getElementById("first_name_kana_error");
  const firstNameKanaInput = document.getElementById("first_name_kana");
  const companyNameErrorMessage = document.getElementById("company_name_error");
  const companyNameInput = document.getElementById("company_name");
  const companyNameKanaErrorMessage = document.getElementById("company_name_kana_error");
  const companyNameKanaInput = document.getElementById("company_name_kana");
  const phoneNumberErrorMessage = document.getElementById("phone_number_error");
  const phoneNumberInput = document.getElementById("phone_number");
  const phoneNumberConfirmationErrorMessage = document.getElementById("phone_number_confirmation_error");
  const phoneNumberConfirmationInput = document.getElementById("phone_number_confirmation");
  const passwordErrorMessage = document.getElementById("password_error");
  const passwordInput = document.getElementById("password");
  const passwordConfirmationErrorMessage = document.getElementById("password_confirmation_error");
  const passwordConfirmationInput = document.getElementById("password_confirmation");

  submitForm.addEventListener("submit", (event) => {
    let numberOfErrors = 0;

		// 姓のバリデーション
		if (lastNameInput.value === "") {
			numberOfErrors++;
			lNameErrorMessage.innerHTML = "氏名（姓）を入力して下さい";
		} else {
			lNameErrorMessage.innerHTML = "";
		}
		// 名のバリデーション
		if (firstNameInput.value === "") {
			numberOfErrors++;
			fNameErrorMessage.innerHTML = "氏名（名）を入力して下さい";
		} else {
			fNameErrorMessage.innerHTML = "";
		}
		// 会社名のバリデーション
		if (companyNameInput.value === "") {
			numberOfErrors++;
			companyNameErrorMessage.innerHTML = "会社名・屋号を入力してください";
		} else {
			companyNameErrorMessage.innerHTML = "";
		}
    const companyNameKanaChecked = nameKana_check(companyNameKanaInput.value);
    if (companyNameKanaChecked === false) {
      numberOfErrors++;
      companyNameKanaErrorMessage.innerHTML = "会社名・屋号（フリガナ）は全角カタカナで入力してください（例：カイシャメイ）";
    } else {
      companyNameKanaErrorMessage.innerHTML = "";
    }



    // 姓カナのバリデーション
    const lastNameKanaChecked = nameKana_check(lastNameKanaInput.value);
    if (lastNameKanaChecked === false) {
      numberOfErrors++;
      lNameKanaErrorMessage.innerHTML = "フリガナ（セイ）は全角カタカナで入力してください（例：ヤマダ）";
    } else {
      lNameKanaErrorMessage.innerHTML = "";
    }
    // 名カナのバリデーション
    const firstNameKanaChecked = nameKana_check(firstNameKanaInput.value);
    if (firstNameKanaChecked === false) {
      numberOfErrors++;
      fNameKanaErrorMessage.innerHTML = "フリガナ（メイ）は全角カタカナで入力してください（例：タロウ）";
    } else {
      fNameKanaErrorMessage.innerHTML = "";
    }

    // 郵便番号のバリデーション
    const postChecked = postCode_check(postInput.value);
    if (postChecked === false) {
      numberOfErrors++;
      postErrorMessage.innerHTML = "郵便番号は7桁の半角数字とハイフンを組み合わせて入力してください（例：123-4567）";
    } else {
      postErrorMessage.innerHTML = "";
    }

    //電話番号のバリデーション
    const phoneChecked = phoneNumber_check(phoneNumberInput.value);
    if (phoneChecked === false) {
      numberOfErrors++;
      phoneNumberErrorMessage.innerHTML = "電話番号は0から始まる10桁か11桁の半角数字とハイフンを組み合わせて正しく入力してください（例：010-1234-5678）";
    } else {
      phoneNumberErrorMessage.innerHTML = "";
    }
		// 電話番号確認のバリデーション
		if (phoneNumberConfirmationInput.value === phoneNumberInput.value) {
			phoneNumberConfirmationErrorMessage.innerHTML = "";
		} else {
			numberOfErrors++;
			phoneNumberConfirmationErrorMessage.innerHTML = "電話番号が一致しません";
		}

    // チェックボックスのバリデーション
    const checkCount = count_checked();
    if (checkCount === 0) {
      numberOfErrors++;
      errorMessage.innerHTML = "事業内容を入力してください";
    } else {
			errorMessage.innerHTML = "";
		}
    // パスワードのバリデーション
    const passwordChecked = password_check(passwordInput.value);
    if (passwordChecked === false) {
      numberOfErrors++;
      passwordErrorMessage.innerHTML = "パスワードは半角8文字以上で入力してください";
    } else {
			passwordErrorMessage.innerHTML = "";
		}
		// パスワード確認のバリデーション
		if (passwordConfirmationInput.value === passwordInput.value) {
			passwordConfirmationErrorMessage.innerHTML = "";
		} else {
			numberOfErrors++;
			passwordConfirmationErrorMessage.innerHTML = "パスワードが一致しません";
		}
		

    if (numberOfErrors !== 0) {
      // イベント伝搬の停止
      event.stopPropagation();
      // イベントキャンセル
      event.preventDefault();
      return;
    }
  });
});



const nameKana_check = (value) => {
  const reg = /^[ァ-ンヴー]+$/;
  const result = reg.test(value);
  return result;
}
const companyNameKana_check = (value) => {
  const reg = /^[ァ-ンヴー]+$/;
  const result = reg.test(value);
  return result;
}
const postCode_check = (value) => {
  const reg = /^[0-9]{3}-[0-9]{4}$/;
  const result = reg.test(value);
  return result;
}
const phoneNumber_check = (value) => {
  const reg = /\d{2,4}-\d{2,4}-\d{4}/;
  const result = reg.test(value);
  return result;
}
const password_check = (value) => {
  const reg = /^([a-zA-Z0-9]{8,})$/;
  const result = reg.test(value);
  return result;
}

const count_checked = () => {
  let checked = 0;
  for(let i = 1; i < 10; i++) {
    const checkbox = document.getElementById(`service_category_${i}`);
    if(checkbox.checked === true) {
      checked++;
    }
  }
  return checked;
}